import { Injectable, inject } from '@angular/core';
import { ISpinnerManager } from '../interface-spinner';
import {MatSnackBar, MatSnackBarRef, TextOnlySnackBar} from '@angular/material/snack-bar';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';
import { ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { GenericComponent } from '../modals/generic/generic.component';

@Injectable({
  providedIn: 'root',
  
})
export class NotificationService {

  timeout: NodeJS.Timeout | null = null;
  _manager: ISpinnerManager | null = null;
  _snackBar: MatSnackBar;
  _snackBarRef!: MatSnackBarRef<TextOnlySnackBar>;
  modalRef?: BsModalRef;
  modalService = inject(BsModalService);
  constructor(private snackBar: MatSnackBar) { 
    this._snackBar = snackBar;
  }

  set manager(mgr: ISpinnerManager){
    this._manager = mgr;
    console.log("Se establecio spinner manager");
  }
  setSpinnerStatus(value: boolean, timeout: number = 0){
    
    if (this._manager != null){
      console.log(`setSpinnerStatus(${value}, ${timeout})`);
      if (!value && this.timeout != null){
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this._manager.setSpinnerStatus(value);
      
      if (value && timeout){
        if (this.timeout != null){
          clearTimeout(this.timeout);
          this.timeout = null;
        }
        this.timeout = setTimeout(() => {
          this._manager!.setSpinnerStatus(false);
        }, timeout);
      }
  }
  
  }
  showModal(initialState:ModalOptions){
    console.log("Showmodal desde notificationservice")
    this.modalRef = this.modalService.show(GenericComponent, initialState);
    this.modalRef.content.closeBtnName = 'Close';
  }

  showSnackBar(message: string){
    this.showSnackBarTimeout(message, environment.snackbar_time_dismiss);
    
  }
  showSnackBarTimeout(message: string, timeout: number){
    setTimeout(() => {
      console.log(`showSnackBarTimeout(${message}, ${timeout})`);
    this._snackBarRef =  this._snackBar.open(message, "Ok", {duration: timeout});
    this._snackBarRef.onAction().subscribe({
      next: next => {
        console.log("snackBar::Next");
      },
      error: error => {
        console.log("snackBar::error");
      },
      complete: () => {
        console.log("snackBar::complete");
      }
    })
    }, 1);
    
  }
}
